import { Resource as e } from "@coveo/platform-client";
const t = class t extends e {
  /**
   * Get the definition of a org.
   */
  getDefinition() {
    return this.api.get(
      super.buildPath(`${t.baseUrl}/${this.api.organizationId}/definition`)
    );
  }
};
t.baseUrl = "/rest/organizations";
let s = t;
export {
  s as OrganizationDefinitionResource
};
//# sourceMappingURL=OrganizationDefinitionResource.js.map
